import { useQuery } from '@tanstack/react-query';
import { fetchUserDrafts } from '../../services';

export const useFetchUserDrafts = () => {
  return useQuery(['fetchUserDrafts'], fetchUserDrafts);
};
